<template>
  <div class="content_box mt10" v-if="notice">
    <template v-if="notice.calculation">
      <span class="content_title_span">Freetime Calculation</span>
      <div class="cont text_left">
        <ul class="bul_list_sm" style="list-style: none;">
          <li>
            <template v-for="(line, i) in notice.calculation">{{ line }}<br :key="'calc-' + i" /></template>
          </li>
        </ul>
      </div>
    </template>
    <br v-if="notice.calculation && notice.precautions" />
    <template v-if="notice.precautions">
      <span class="content_title_span">Precautions</span>
      <div class="cont text_left">
        <ul class="bul_list_sm" style="list-style: none;">
          <li>
            <template v-for="(line, i) in notice.precautions">{{ line }}<br :key="'prec-' + i" /></template>
          </li>
        </ul>
      </div>
    </template>
  </div>
</template>

<script>
import freetimeNoticeConfig from './freetimeNoticeConfig'

export default {
  name: 'FreetimeNoticeInfo',
  props: {
    ctrCd: { type: String, default: '' },
    eiCatCd: { type: String, default: '' },
    bkgPlcCd: { type: String, default: '' }
  },
  computed: {
    notice () {
      return freetimeNoticeConfig.find(n =>
        n.ctrCd === this.ctrCd &&
        (!n.eiCatCd || n.eiCatCd === this.eiCatCd) &&
        (!n.bkgPlcCd || n.bkgPlcCd === this.bkgPlcCd)
      )
    }
  }
}
</script>

<style scoped>
.content_title_span {
  font-size: 18px;
  font-weight: 500;
  color: #000;
}
.bul_list_sm >li:before {
  content: none;
}
</style>
